/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FinnairServiceRequestItem } from '../../models/finnair-service-request-item';

export interface SetServices$Params {
  cartId: string;
  hash?: string;
  locale?: string;
      body: Array<FinnairServiceRequestItem>
}

export function setServices(http: HttpClient, rootUrl: string, params: SetServices$Params, context?: HttpContext): Observable<DapiHttpResponse<void>> {
  const rb = new DapiRequestBuilder(rootUrl, setServices.PATH, 'post');

  if (params) {
    rb.path('cartId', params.cartId, {});
    rb.query('hash', params.hash, {});
    rb.query('locale', params.locale, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as DapiHttpResponse<void>;
    }),
    catchErrorAsJson()
  );
}

setServices.PATH = '/api/v2/cart/{cartId}/services';
